import i18next from "i18next";
import { initLitI18n, translate } from "lit-i18n";
import { logger } from "../util/Logger";
import { en } from "./en";
import { tr } from "./tr";
import { de } from "./de";

i18next.use(initLitI18n).init({
  resources: {
    en: {
      translation: en,
    },
    tr: {
      translation: tr,
    },
    de: {
      translation: de,
    },
  },
  lng: navigator.language,
  fallbackLng: "en",
});

logger.debug("navigator.language", navigator.language);

export { translate as t };
